// @flow

import * as React from 'react';
import { Flex, Box } from 'react-system';
import * as icons from '../icons';
import { useLocale } from '../hooks/locale';
import { useTheme } from '../theme';

export const NoPhoto = (): React.Node => {
  const { t } = useLocale();
  const { colors, text } = useTheme();

  return (
    <Flex
      css={{
        width: '100%',
        height: '100%',
        backgroundColor: colors.grey100,
      }}
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      aria-hidden={true}
    >
      <Box>
        <icons.Photo fill={colors.grey400} size={60} />
      </Box>
      <Box
        css={[
          text.ellipsis,
          text.subtitle1,
          {
            maxWidth: '100%',
            color: colors.grey400,
          },
        ]}
      >
        {t('noPhotos')}
      </Box>
    </Flex>
  );
};
